"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CfgCountryEditor = /** @class */ (function (_super) {
    __extends(CfgCountryEditor, _super);
    function CfgCountryEditor(props) {
        return _super.call(this, props) || this;
    }
    CfgCountryEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    code: _item.code,
                    is_unknown: _item.is_unknown,
                    is_deprecated: _item.is_deprecated,
                    phone_prefix_inner: _item.phone_prefix_inner,
                    phone_prefix_outer: _item.phone_prefix_outer,
                    css_classname: _item.css_classname
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(_this.props.lang.editor.breadcrumb.edit_country);
                });
            }
        }
        else {
            this.setState({
                title: "",
                code: "",
                is_unknown: false,
                is_deprecated: false,
                phone_prefix_inner: "7",
                phone_prefix_outer: "+7",
                css_classname: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(_this.props.lang.editor.breadcrumb.new_country);
            });
        }
        this.doReSetRules();
    };
    CfgCountryEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            code_rules: { isError: false },
            phone_prefix_inner_rules: { isError: false },
            phone_prefix_outer_rules: { isError: false }
        });
    };
    CfgCountryEditor.prototype.OnUpdateDataClick = function () {
        var _this = this;
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                code: this.state.code,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated,
                is_unknown: this.state.is_unknown,
                phone_prefix_inner: this.state.phone_prefix_inner,
                phone_prefix_outer: this.state.phone_prefix_outer,
                css_classname: this.state.css_classname
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.editor.message.country_changed);
            });
        }
    };
    CfgCountryEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: {
                    isError: true,
                    errorMessage: this.props.lang.editor.error.field_title_empty
                }
            });
            return false;
        }
        if ((!this.state.code) || (this.state.code.length === 0)) {
            this.setState({
                code_rules: {
                    isError: true,
                    errorMessage: this.props.lang.editor.error.field_code_empty
                }
            });
            return false;
        }
        if ((!this.state.phone_prefix_inner) || (this.state.phone_prefix_inner.length === 0)) {
            this.setState({
                phone_prefix_inner_rules: {
                    isError: true,
                    errorMessage: "Внутренний префикс не заполнен!"
                }
            });
            return false;
        }
        if ((!this.state.phone_prefix_outer) || (this.state.phone_prefix_outer.length === 0)) {
            this.setState({
                phone_prefix_outer_rules: {
                    isError: true,
                    errorMessage: "Внешний префикс не заполнен!"
                }
            });
            return false;
        }
        return true;
    };
    CfgCountryEditor.prototype.OnNewDataClick = function () {
        var _this = this;
        if (this.isDataValid()) {
            this.props.data.AddData({
                code: this.state.code,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated,
                is_unknown: this.state.is_unknown,
                phone_prefix_inner: this.state.phone_prefix_inner,
                phone_prefix_outer: this.state.phone_prefix_outer,
                css_classname: this.state.css_classname
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.editor.message.country_added);
            });
        }
    };
    CfgCountryEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CfgCountryEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return this.props.lang.editor.title.new_country;
        }
        else {
            return this.props.lang.editor.title.edit_country;
        }
    };
    CfgCountryEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 530 },
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: this.props.lang.editor.fields.title.caption,
                    placeholder: this.props.lang.editor.fields.title.placeholder
                }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: this.props.lang.editor.fields.code.caption,
                    placeholder: this.props.lang.editor.fields.code.placeholder
                }, value: this.state.code, onValueChanged: function (newVal) {
                    _this.setState({
                        code: newVal,
                        code_rules: { isError: false }
                    });
                }, required: true, rules: this.state.code_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Внутренний префикс:",
                    placeholder: "Внутренний префикс телефона"
                }, value: this.state.phone_prefix_inner, onValueChanged: function (newVal) {
                    _this.setState({
                        phone_prefix_inner: newVal,
                        phone_prefix_inner_rules: { isError: false }
                    });
                }, required: true, rules: this.state.phone_prefix_inner_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Внешний префикс:",
                    placeholder: "Внешний префикс телефона"
                }, value: this.state.phone_prefix_outer, onValueChanged: function (newVal) {
                    _this.setState({
                        phone_prefix_outer: newVal,
                        phone_prefix_outer_rules: { isError: false }
                    });
                }, required: true, rules: this.state.phone_prefix_outer_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Css класс:",
                    placeholder: "Css класс"
                }, value: this.state.css_classname, onValueChanged: function (newVal) {
                    _this.setState({
                        css_classname: newVal
                    });
                }, required: false }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: this.props.lang.editor.checkboxes.deprecated, value: this.state.is_deprecated, onChecked: function (checked) {
                    _this.setState({
                        is_deprecated: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: this.props.lang.editor.checkboxes.unknown, value: this.state.is_unknown, onChecked: function (checked) {
                    _this.setState({
                        is_unknown: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: {
                    btnEdit: this.props.lang.editor.buttons.save,
                    btnNew: this.props.lang.editor.buttons.create,
                    btnGoBack: this.props.lang.editor.buttons.back
                }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CfgCountryEditor;
}(React.Component));
exports.default = CfgCountryEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_country/ui/component/CfgCountryEditor.tsx
// module id = 2050
// module chunks = 0